import './public.css';
import Loading from './loading';

export default function Button({ onClick, children, className = '', type = 1, loading = false, ...props }) {
    const baseClass = "flex h-10 rounded-none p-6 transition-all duration-150 ease-in-out w-full text-center justify-center items-center gap-2 font-semibold text-sm letter-spacing tracking-wider";

    let typeClasses = "";

    switch (type) {
        case 2:
            typeClasses = "bg-secondary text-white border-2 border-secondary hover:opacity-90";
            break;
        case 3:
            typeClasses = "bg-red-800 text-white border-2 border-red-800 hover:opacity-90";
            break;
        case 4:
            typeClasses = "bg-emerald-600 text-white border-2 border-emerald-600 hover:opacity-90";
            break;
        case 5:
            typeClasses = "bg-muted hover:bg-neutral-200 border-2 border-border text-foreground";
            break;
        default:
            typeClasses = "bg-primary text-white border-2 border-primary hover:opacity-90";
            break;
    }

    return (
        <button
            onClick={onClick}

            className={`${baseClass} ${typeClasses} ${className}`}
            disabled={loading}
            {...props}
        >
            {loading ? (<Loading visible={true} />) : (children)}
        </button>
    );
}
